import { getGoodsConfigByType } from '../services'
import { useEffect, useState } from 'react'
import { useModel } from 'umi'
import { getStorage, setStorage } from '../functions/onStorage'

const getButtonStyle = (setting: IGoodsConfigParams): IButtonConfigParams => {
  const { buttonStyle } = setting || {}
  const { borderRadius, borderStyle, color, backgroundColor } =
    buttonStyle || {}
  if (borderStyle === 'line') {
    return {
      borderRadius,
      color,
      border: '1px solid ' + backgroundColor,
    }
  }
  return {
    borderRadius,
    color,
    backgroundColor,
  }
}
export type categoryTypes =
  | 'GLOBAL'
  | 'DG'
  | 'SL'
  | 'FT'
  | 'GC'
  | 'MG'
  | 'LS'
  | 'GV'
  | 'JD'
  | ''
  | 'LOGIN'
  | 'AUTHORIZE'
  | 'SC'
  | 'TPS'

export interface IGoodsConfigParams {
  h5Setting?: {
    [key: string]: any
  }
  tagStyle?: {
    [key: string]: any
  }
  buttonStyle?: {
    [key: string]: any
  }
  certificatePage?: {
    [key: string]: any
  }
  lang?: {
    [key: string]: any
  }
  base?: {
    [key: string]: any
  }
}

export interface IButtonConfigParams {
  borderRadius: number
  color: string
  border?: string
  backgroundColor?: string
}

export interface IStringifyFormData {
  [key: string]: string
}

export function parseFormData(
  data: IStringifyFormData | any,
): IGoodsConfigParams | {} {
  if (!data) return {}
  for (let i in data) {
    const o = data[i]
    try {
      if (!o && typeof o === 'string') {
        data[i] = null
      } else if (o && typeof o === 'string') {
        data[i] = JSON.parse(o)
      }
    } catch (e) {}
  }
  return data
}
// 品类的的商品设置
export default function useCategorySet<T = ''>(
  categoryType?: categoryTypes | T,
  _tenantCode?: string,
): {
  categorySetting: IGoodsConfigParams
  buttonSetting: IButtonConfigParams
  setCategoryType: (categoryType: categoryTypes | T) => void
  setTenantCode: (tenantCode: string) => void
  getCurrentStyles: (outCategoryType?: string) => void
} {
  const [currentCategoryType, setCurrentCategoryType] = useState<
    categoryTypes | T
  >(categoryType || '')
  const [tenantCode, setTenantCode] = useState<string>(
    _tenantCode || getStorage('tenantCode') || '',
  )
  const [categorySetting, setCategorySetting] = useState<IGoodsConfigParams>({})
  const [buttonSetting, setButtonSetting] = useState<IButtonConfigParams>({})

  const { qiankunGlobalState, setQiankunGlobalState } =
    useModel('@@qiankunStateFromMaster') || useModel('@@qiankunStateForSlave')
  const { categorySettingState } = qiankunGlobalState

  const getCurrentStyles = async (outCategoryType?: string) => {
    try {
      const res: any = await getGoodsConfigByType({
        categoryType: outCategoryType || currentCategoryType,
        tenantCode: tenantCode,
      })
      if (res?.code !== -1) {
        const newCategorySettingState = parseFormData({
          ...categorySettingState,
          [outCategoryType || currentCategoryType]: parseFormData(res),
        })
        // @ts-ignore
        setCategorySetting(
          newCategorySettingState[outCategoryType || currentCategoryType],
        )
        setButtonSetting(getButtonStyle(parseFormData(res)))
        setQiankunGlobalState({
          categorySettingState: newCategorySettingState,
        })
        return {
          categorySetting:
            newCategorySettingState[outCategoryType || currentCategoryType],
          buttonSetting: getButtonStyle(parseFormData(res)),
        }
      }
      return {
        categorySetting: '',
        buttonSetting: '',
      }
    } catch (e) {
      return {
        categorySetting: '',
        buttonSetting: '',
      }
    }
  }
  useEffect(() => {
    if (!currentCategoryType) return
    getCurrentStyles()
    // getGoodsConfigByType({
    //   categoryType: currentCategoryType,
    //   tenantCode: tenantCode,
    // }).then((res) => {
    //   if (res) {
    //     const newCategorySettingState = parseFormData({
    //       ...categorySettingState,
    //       [currentCategoryType]: parseFormData(res),
    //     })
    //     // @ts-ignore
    //     setCategorySetting(newCategorySettingState[currentCategoryType])
    //     setButtonSetting(getButtonStyle(parseFormData(res)))
    //     setQiankunGlobalState({
    //       categorySettingState: newCategorySettingState,
    //     })
    //     return {
    //       categorySetting: newCategorySettingState[currentCategoryType],
    //       buttonSetting: getButtonStyle(parseFormData(res))
    //     }
    //   }
    // })
  }, [currentCategoryType, tenantCode, categoryType])
  return {
    categorySetting,
    buttonSetting,
    setCategoryType: setCurrentCategoryType,
    setTenantCode,
    getCurrentStyles,
  }
}
